exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-hidden {\n  position: absolute;\n  width: 0px;\n  height: 0px;\n  visibility: hidden;\n  opacity: 0;\n  z-index: -1; }\n\nbutton {\n  margin: 0 5px 7px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/dashboard-admin/dashboard-export-csv/dashboard-export-csv.component.scss
// module id = ../../../../../angular/app/components/defaults/dashboard-admin/dashboard-export-csv/dashboard-export-csv.component.scss
// module chunks = 1